var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "productIncAndDescMain" }, [
    _c(
      "div",
      { staticClass: "minusWrapper", on: { click: _vm.purchasedNumberDesc } },
      [_c("div", { staticClass: "minusIcon" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "purchaseNumber",
        on: { click: _vm.purchasedNumberCustom }
      },
      [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "addWrapper", on: { click: _vm.purchasedNumberInc } },
      [
        _c("div", { staticClass: "addIcon1" }),
        _vm._v(" "),
        _c("div", { staticClass: "addIcon2" })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }